import { css } from '@emotion/react';

import { screens } from '../shared/styles';

export const sentWrapperStyles = css`
  align-self: flex-end;
  max-width: 90%;
  width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  padding-top: 0;

  &:first-child {
    padding-top: var(--spacing-4);
  }
`;

export const receivedWrapperStyles = css`
  align-self: flex-start;
  width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  padding-top: var(--spacing-4);
`;

export const containerStyles = css`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  max-height: 100%;

  @media (min-width: ${screens.lg}) {
    height: 765px;
    max-height: 80vh;
  }
`;

export const thinkingRowStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--text-primary);
`;

export const thinkingTextStyles = css`
  background: linear-gradient(
    90deg,
    var(--color-neutral-400, #b1bccb) 0%,
    var(--text-primary, #202327) 50%,
    var(--color-neutral-400, #b1bccb) 100%
  );
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ltchat-pulse 1.3s linear infinite;

  @keyframes ltchat-pulse {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
`;

export const badge = css`
  width: var(--spacing-11);
  height: var(--spacing-11);
  border-radius: var(--radius-round);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-500);
  color: var(--color-base-white);
`;

export const closeButtonContent = css`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
`;

export const scrollToBottomButtonStyles = css`
  position: absolute;
  bottom: var(--spacing-4);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
  z-index: 2;

  &.visible {
    opacity: 1;
    visibility: visible;
  }
`;
